import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '@ipreo/muni-shared';
import { CardHeaderComponent } from '../gameday/components/card-header/card-header.component';
import { GamedaySharedModule } from '../shared/shared.module';
import { ProfileModule } from '../profile/profile.module';
import { CategoryColorComponent } from './components/tranche-orders-table/category-color/category-color.component';
import { TrancheDetailsComponent } from './components/tranche-details/tranche-details.component';
import { TrancheOrdersTableComponent } from './components/tranche-orders-table/tranche-orders-table.component';
import { TrancheSummaryComponent } from './components/tranche-summary/tranche-summary.component';
import { BarChartComponent } from './components/tranche-summary/bar-chart/bar-chart.component';
import { RangePipe } from './pipes/range.pipe';

export const agGridModule = AgGridModule;

@NgModule({
  imports: [
    CommonModule,
    ProfileModule,
    agGridModule,
    SharedModule,
    GamedaySharedModule
  ],
  declarations: [
    TrancheSummaryComponent,
    TrancheDetailsComponent,
    TrancheOrdersTableComponent,
    CardHeaderComponent,
    CategoryColorComponent,
    BarChartComponent,
    RangePipe
  ],
  exports: [CardHeaderComponent, TrancheDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TrancheModule {}
